import axios from "axios";

// When running inside a Capacitor iOS/Android shell, always talk to the live production API.
// Otherwise use the env-configured URL (preview or local dev).
const isNativeApp = typeof window !== "undefined" && (window.Capacitor?.isNativePlatform?.() || window.Capacitor?.getPlatform?.() === "ios" || window.Capacitor?.getPlatform?.() === "android");
const BACKEND_URL = isNativeApp
  ? "https://fairwaylabgolf.com"
  : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials: true makes cookie-based auth work cross-origin
export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach the session token from localStorage as a Bearer header on every request.
// This is needed for the iOS app (Capacitor) where cookies can't cross app<->fairwaylabgolf.com.
api.interceptors.request.use((config) => {
  try {
    const token = typeof window !== "undefined" ? localStorage.getItem("session_token") : null;
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (e) { /* ignore */ }
  return config;
});

// ---------- Auth ----------
export const api_authSession = (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data);
export const api_authMe = () => api.get("/auth/me").then((r) => r.data);
export const api_authLogout = () => api.post("/auth/logout").then((r) => {
  try { localStorage.removeItem("session_token"); } catch (e) { /* ignore */ }
  return r.data;
});
export const api_deleteAccount = () => api.delete("/me").then((r) => r.data);

// ---------- Profile (current user) ----------
export const api_getMyProfile = () => api.get("/me/profile").then((r) => r.data);
export const api_upsertMyProfile = (payload) => api.put("/me/profile", payload).then((r) => r.data);

// ---------- Sessions ----------
export const api_generateSession = (payload) => api.post("/sessions/generate", payload).then((r) => r.data);
export const api_getSession = (id) => api.get(`/sessions/${id}`).then((r) => r.data);
export const api_submitFeedback = (payload) => api.post("/sessions/feedback", payload).then((r) => r.data);
export const api_listMySessions = () => api.get("/me/sessions").then((r) => r.data);
export const api_deleteSession = (id) => api.delete(`/sessions/${id}`).then((r) => r.data);
